import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export function parallax() {
  const imageWrappers = document.querySelectorAll(
    '[data-js="parallax-wrapper"]'
  );

  imageWrappers.forEach((imageWrapper) => {
    const image = imageWrapper.querySelector("img");
    const endPosition = imageWrapper.dataset.parallaxEndPosition
      ? imageWrapper.dataset.parallaxEndPosition
      : "bottom top";

    gsap.to(image, {
      scrollTrigger: {
        trigger: imageWrapper,
        start: "top bottom",
        end: endPosition,
        scrub: 2,
        onUpdate: (self) => {
          const progress = self.progress;
          const imageHeight = image.clientHeight;
          const wrapperHeight = imageWrapper.clientHeight;
          const translateY = (wrapperHeight - imageHeight) * progress;
          gsap.set(image, { y: translateY });
        },
      },
    });
  });
}
